import React, { useEffect, useState } from 'react'
import style from "./VerifyUsers.module.css"
import ShimmerLoader from '../../../../components/ShimmerLoader'
import API from "../../../../ApiConfig"
import { ISSUERS_RECENT } from '../../../../Utils/constant'
import cogoToast from 'cogo-toast-react-17-fix'
const AuthNumberIssuers = () => {
    const [Issuers, setIssuers]=useState([])
    const [loading, setLoading]=useState(false)


    useEffect(()=>{

        getRecentIssuers()
    },[])
    const getRecentIssuers=()=>{
        setLoading(true)
        API.get(ISSUERS_RECENT)
        .then(res=>{
            if(res.data.status==200){
                setLoading(false)
                setIssuers(res.data.data)
            }

        })
        .catch(err=>{
            setLoading(false)
            cogoToast.error(err.response.data.message)
        })
    }
  return (

    <>
    <div className={style.Container}>
        <div className={style.boxContainer}>
            <h2 className={style.headline}>Our Platform Issuers</h2>
            <div className={style.partnersGrid}>
                {loading?[...Array(10)].map((_, index)=>(
                        <div key={index} className={style.partnerBox}>
                            <ShimmerLoader width="15rem" height="10rem"/>
                            </div>))
                :
Issuers && Issuers.map((partner, index) => (
        partner.company_logo!==null&&   <div key={index} className={style.partnerBox} style={{ animationDelay: `${index * 0.2}s` }}>
          <img src={partner.company_logo} alt={partner.company_name} />
          </div>
        ))}
      </div>
        </div>
    </div>
    </>
  )
}

export default AuthNumberIssuers